import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import der Icons für Passwort

import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/PopupDatasheet.css'
import './new_pages.css'


function UserAdministrationNew({ closeNewPopup, fields, sortedInstitutionOptions, sortedRoleOptions, formatTimestampNow, 
  fetchPersons, copiedData, newSaveID, handleFocus, handleBlur, validateField, setErrors, errors, setErrorMessage, 
  setShowErrorModal }) {
  
  const [showPassword, setShowPassword] = useState(false); // State zum Umschalten der Passwortsichtbarkeit

  const id_role = window.localStorage.getItem('id_role');
  const id_institution = window.localStorage.getItem('id_institution');

  const access_token = window.localStorage.getItem('access_token');

  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState ({
    // machinetype:
    id_person: '',
    institution_name: '',
    role_name: '',
    firstname: '',
    lastname: '',
    username: '',
    email: '',
    password: '',
    timestamp: '',    
  })
  

  useEffect(() => {
    // Wenn kopierter Datensatz vorhanden ist, setze ihn in den Zustand
    if (copiedData) {
      setPost(copiedData);
    }
    }, [copiedData]);

  
  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, value, type, checked } = event.target;
    setPost(prevPost => ({
      ...prevPost,
      [name]: type === 'checkbox' ? checked : value,
    }));

    if (errors[name]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: null,
      }));
    }
  };

  
  // Funktion zum Speichern einer neuen Person mit aktuellem Zeitstempel
  const handleNewSave = async () => {
    let newErrors = {};

    try {
      // Schritt 1: Alle Felder auf Leerwert pruefen und Fehler sammeln
      fields.forEach((field) => {
        const value = String(post[field.name] || ''); // Standardwert auf leer setzen, falls undefined
        const rules = field.validate || {};
        
        // Validierung aufrufen und Fehler im neuen Fehlerobjekt speichern
        const error = validateField(field.name, value, rules, (errorObj) => {
          newErrors = { ...newErrors, ...errorObj };
        });
        
        if (error) {
          newErrors[field.name] = error;
        }
      });

      // Schritt 2: Fehler im Zustand speichern
      setErrors(newErrors);

      // Schritt 3: Ueberprüfen, ob Fehler vorhanden sind
      const hasErrors = Object.values(newErrors).some((error) => error !== '');

      if (hasErrors) {
        // Zeige das Modal, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      // Fehler zuruecksetzen, falls alles korrekt ist
      setErrors({});

      const timestamp = formatTimestampNow(); // Aktuellen Zeitstempel abrufen und formatieren
      const newPost = { ...post, id_institution, timestamp }; // Zeitstempel zum neuen Eintrag hinzufuegen

      const response = await axios.post(`${url_root}/new_knit_person_ext`, newPost,
        {
          headers: {
              'Authorization': `Bearer ${access_token}`
          }
        }
      );

      // Ueberpruefen des Statuscodes in der API-Antwort
      const statusCode = response.status;
      if (statusCode === 282) {
        setErrorMessage("Dieser Benutzername ist schon vergeben.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis ein neuer Name eingegeben ist
      } else if (statusCode === 281) {
        setErrorMessage("Bitte geben Sie einen Benutzernamen ein.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis ein Name eingegeben ist
      }

      const id_person = response.data.id_person;
      fetchPersons(); // Tabelle aktualisieren
      newSaveID(id_person); // ID weitergeben, um den neuen Datensatz zu markieren
      closeNewPopup(); // Popup für neue Eintraege schliessen
    } catch (error) {
      console.error('Fehler beim Speichern des neuen Eintrags:', error);
    }
  };



  return (   
    <div className='new-popup-page'>
      <div className='new-title'>
        <h3>Hier können Sie eine neue Person hinzufügen:</h3>
      </div>

      {fields.map(field => (
        // Bedingung für institution_name: nur anzeigen, wenn id_role == 1
        field.name === 'institution_name' && id_role > 1 ? null : (
        <div key={field.name} className="new-input-row">
          <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>

          <div className="new-input-with-unit">
            {field.name === 'password' ? (
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name={field.name}
                  value={post[field.name]}
                  onChange={handleInput}
                />
                <div
                  className="password-toggle-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>

            /* institution_name wird nur beim NEU anlegen als dropdown angezeigt */
            ) : field.name === 'institution_name' ? (
            <>
              <select
                onChange={handleInput} 
                name={field.name} 
                value={post[field.name]}
                onFocus={(event) => handleFocus(event, setErrors)}
                // Manuelle Validierung für institution_name aufrufen
                onBlur={(e) => {const value = e.target.value;
                  // Wenn das Feld leer ist, setze eine Fehlermeldung
                  if (!value) {
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      institution_name: "Bitte wählen Sie eine Institution."
                    }));
                  } else {
                    // Entferne den Fehler, wenn eine Institution ausgewaehlt ist
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      institution_name: ''
                  }));
                }
              }}         
              >
                
                <option value=""></option>
                {sortedInstitutionOptions.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              {/* Fehlernachricht für institution_name anzeigen */}
              {errors.institution_name && (
                <span className="error-message">{errors.institution_name}</span>
              )}
            </>

            ) : field.type === 'select' ? (
            <>
              <select 
                onChange={handleInput} 
                name={field.name} 
                value={post[field.name]}
                onFocus={(event) => handleFocus(event, setErrors)}
                onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                  validateField(name, value, rules, setErrors))}
              >
                <option value=""></option>
                {field.name === 'institution_name' && sortedInstitutionOptions.length > 0 ? (
                  sortedInstitutionOptions.map((option, index) => (              
                    <option key={index} value={option}>
                      {option}
                    </option>
                ))             
              
                ) : field.name === 'role_name' && sortedRoleOptions.length > 0 ? (
                  sortedRoleOptions.map((option, index) => (              
                    <option key={index} value={option}>
                      {option}
                    </option>
                ))             
              
              ) : null}
            </select>
              {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
              {errors[field.name] && (
                <span className="error-message">{errors[field.name]}</span>
              )}
            </>

            ) : (
              <>
                <input
                  type={field.type}
                  name={field.name}
                  value={post[field.name]}
                  onChange={handleInput}

                  onFocus={(event) => handleFocus(event, setErrors)}
                  onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                    validateField(name, value, rules, setErrors))}
                />
                {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}
              </>
              )}
            </div>
          </div>
          )
        ))}

      <div className='new-input-save-cancel'>
        <button onClick={() => closeNewPopup()}>ABBRECHEN</button> 
        <button onClick={() => handleNewSave()}>SPEICHERN</button>       
      </div>        
    </div>
    
  )
}

export default UserAdministrationNew
